module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_C.417bdfb3.jpg";